import { useFormik } from "formik";
import { isEmpty } from "lodash";
import { useEffect } from "react";

export default function useForm(params) {
  const form = useFormik(params);
  useEffect(() => {
    const hasError = !isEmpty(form.errors);
    if (hasError) {
      const firstErrorElement = document.querySelector(`[aria-invalid=true]`);
      if (firstErrorElement) {
        firstErrorElement.focus({ preventScroll: true });
        firstErrorElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      } else {
        const firstErrorElement = document.querySelector(
          ".chakra-form__error-message"
        );
        if (firstErrorElement) {
          firstErrorElement.focus({ preventScroll: true });
          firstErrorElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }
    }
  }, [form.isSubmitting]);

  return form;
}
